import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Zap, BookOpen } from 'lucide-react';
const differentiators = [{
  icon: Shield,
  title: 'Progresión Estructurada',
  description: 'Cada nivel construye sobre el anterior. No hay saltos ni vacíos. Una formación diseñada pedagógicamente para el aprendizaje real.'
}, {
  icon: Award,
  title: 'Tono Profesional',
  description: 'Sin misticismo vacío ni promesas mágicas. Un enfoque serio, ético y fundamentado que te prepara para ejercer responsablemente.'
}, {
  icon: Zap,
  title: 'Herramientas Prácticas Reales',
  description: 'Protocolos de sesión, técnicas aplicables, guías de chakras y meditaciones. Todo lo que necesitas para empezar a practicar desde el primer día.'
}, {
  icon: BookOpen,
  title: 'Más que Teoría',
  description: 'Cada concepto viene acompañado de su aplicación práctica. Aprenderás haciendo, no solo leyendo.'
}];
export function DifferentiatorsSection() {
  return <section className="py-24 bg-[#0f0a2e]" data-id="element-154">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-157">
            ¿Por Qué Este Sistema es Diferente?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto" data-id="element-158">
          {differentiators.map((item, i) => <motion.div key={i} className="flex gap-6" initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-159">
              <div className="flex-shrink-0" data-id="element-160">
                <div className="w-14 h-14 bg-[#1e1254] rounded-full flex items-center justify-center border border-purple-800" data-id="element-161">
                  <item.icon className="w-7 h-7 text-[#d4af37]" data-id="element-162" />
                </div>
              </div>
              <div data-id="element-163">
                <h3 className="text-xl font-bold text-white mb-2 font-heading" data-id="element-164">
                  {item.title}
                </h3>
                <p className="text-purple-200 leading-relaxed font-light" data-id="element-165">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}